import { render, staticRenderFns } from "./HighlightsGrid.vue?vue&type=template&id=86d1af7a&scoped=true"
import script from "./HighlightsGrid.vue?vue&type=script&lang=js"
export * from "./HighlightsGrid.vue?vue&type=script&lang=js"
import style0 from "./HighlightsGrid.vue?vue&type=style&index=0&id=86d1af7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d1af7a",
  null
  
)

export default component.exports